/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Solution_Complete_ActionInputs */

const en_task_solution_complete_action = /** @type {(inputs: Task_Solution_Complete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete task`)
};

const pt_br2_task_solution_complete_action = /** @type {(inputs: Task_Solution_Complete_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluir atividade`)
};

/**
* | output |
* | --- |
* | "Complete task" |
*
* @param {Task_Solution_Complete_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_solution_complete_action = /** @type {((inputs?: Task_Solution_Complete_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Solution_Complete_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_solution_complete_action(inputs)
	return pt_br2_task_solution_complete_action(inputs)
});